import React from "react";
import CustomizedTimeline from "../modules/CustomTimeline";
import certificate from "../../Assets/svg/certificate logo.svg";
import Button from "../modules/Button";
function ProfessionalProfile(props) {
  const item=props.item

  return (
    <div className="proff-tab">
      <CustomizedTimeline item={item} />
      <div className="certificates">
        {/* <div className="set-title">Certification (2)</div>
        <div className="certificate">
          <div className="certificate-left">
            <div className="set-title">Interaction design foundation</div>
            <div className="md-desc">Desgin Thinking: The Ultimate Guide</div>
            <div className="certified">
              <img src={certificate} alt="certificate" />
              <span className="subTitle">Certified in 2022</span>
            </div>
          </div>
          <div className="certificate-right">
          <Button
              onClickHandler={() => {}}
              value={"View Certification"}
              type={"outlined"}
            />
          </div>
        </div>
        <div className="certificate">
          <div className="certificate-left">
            <div className="set-title">Interaction design foundation</div>
            <div className="md-desc">Desgin Thinking: The Ultimate Guide</div>
            <div className="certified">
              <img src={certificate} alt="certificate" />
              <span className="subTitle">Certified in 2022</span>
            </div>
          </div>
          <div className="certificate-right">
          <Button
              onClickHandler={() => {}}
              value={"View Certification"}
              type={"outlined"}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ProfessionalProfile;
